// extracted by mini-css-extract-plugin
var _1 = "overview_approvals_list_item__iozr1";
var _2 = "overview_approvals_list_item_mod_private__I9hVV";
var _3 = "overview_breadcrumb_project__0425M";
var _4 = "overview_cell__CfZiH";
var _5 = "overview_collapse__n-Unt";
var _6 = "overview_filter__NM7p+";
var _7 = "overview_filter_nav_menu_wrapper__iY9Y6";
var _8 = "overview_filter_trigger_label__VpaEr";
var _9 = "overview_filter_wrapper__92C0I";
var _a = "overview_filter_wrapper_sticky__lGlca";
var _b = "overview_list_table__jlRyf";
var _c = "overview_loading__y+QoD";
var _d = "overview_main__rca5t";
var _e = "overview_over_due__W8eLr";
var _f = "overview_private__bKQHz";
var _10 = "overview_task_name__1Ce8V";
var _11 = "overview_task_name_at_risk__WVNld";
var _12 = "overview_task_name_content__kHi6n";
export { _1 as "approvals_list_item", _2 as "approvals_list_item_mod_private", _3 as "breadcrumb_project", _4 as "cell", _5 as "collapse", _6 as "filter", _7 as "filter_nav_menu_wrapper", _8 as "filter_trigger_label", _9 as "filter_wrapper", _a as "filter_wrapper_sticky", _b as "list_table", _c as "loading", _d as "main", _e as "over_due", _f as "private", _10 as "task_name", _11 as "task_name_at_risk", _12 as "task_name_content" }
